import React, { useMemo, useState } from 'react';
import { InvestigationIdProps } from "../../../../types/investigation";
import { useQuery } from '@apollo/client';
import { gqlSchema } from '../../../../gql/schema';
import * as S from '../styles';
import ShopifyWrapper from '../../../Books/InvestigationCard/ShopifyWrapper';
import { BiCollapse, BiCollapseAlt } from 'react-icons/bi';

const MaterialTab: React.FC<
  InvestigationIdProps & {
    isActive?: boolean;
    setFullScreen?: () => void;
    closeFullScreen?: () => void;
    isTeacher?: boolean;
  }
> = ({ investigationId, kitUrl, isActive, setFullScreen, closeFullScreen, isTeacher = false }) => {

  const [isOverlayVisible, setOverlayVisible] = useState(false);

  const toggleOverlay = () => setOverlayVisible(!isOverlayVisible);
  const { data, loading, error } = useQuery(gqlSchema.BookSchema.queries.getInvestigationMaterial, {
    variables: { investigationId },
    fetchPolicy: 'network-only',
    onError: () => {
    },
  });

  const materialData = data?.getInvestigationMaterial;
  const handle = useMemo(() => {
    if (kitUrl) {
      try {
        return kitUrl.split('?')[0].split('/').pop();
      } catch (e) {
        return '';
      }
    }
    return '';
  }, [kitUrl]);
  const { data: product } = useQuery(gqlSchema.ShopifySchema.queries.LIST.GetShopifyProductByHandle, {
    variables: { handle: handle },
    skip: !handle,
  });
  const shopifyId = product?.getShopifyProductByHandle?.variantId;

      const handleIconClick = () => {

        if (isActive) {
            if (closeFullScreen) {
                closeFullScreen();
            }
        } else {
            if (setFullScreen) {
                setFullScreen();
            }
        }
    };

  return (
    <div>
       <div style={{ display: 'flex', justifyContent: 'flex-end',alignItems: 'flex-start', marginRight: 30}}>
                <S.Icon isTeacher={isTeacher} onClick={handleIconClick} style={{ marginTop: 10 }}>
                    {isActive ? <BiCollapseAlt /> : <BiCollapse />}
                </S.Icon>
            </div>
      <S.TableContainer style={{ position: 'relative' }}>
        {loading ? (
          <S.LoadingMessage>Loading material...</S.LoadingMessage>
        ) : error ? (
          <S.ErrorBlock>
            <S.ErrorMessage>No Material or Simulation to show.</S.ErrorMessage>
          </S.ErrorBlock>
        ) : materialData ? (
          materialData.materialLink && materialData.simulationLink ? (
            <>
              <S.ScrollableBlock key={`${investigationId}-material`}>
                <img
                  src={materialData.materialLink}
                  alt="Material pictorial description"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </S.ScrollableBlock>
            </>
          ) : materialData.simulationLink ? (
            <>
              <S.ScrollableBlock key={`${investigationId}-simulation`}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%'
                }}>
                  <img
                    src={materialData.qrLink}
                    alt="Material pictorial description"
                    style={{
                      width: '60%',
                      height: '60%',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                <a
                  href={materialData?.simulationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    marginTop: '15px',
                    color: '#007bff',
                    textDecoration: 'underline',
                  }}
                >
                  Open QR link in New Tab
                </a>
              </S.ScrollableBlock>
            </>
          ) : materialData.materialLink ? (
            <>
              <S.ScrollableBlock key={`${investigationId}-material`}>
                <img
                  src={materialData.materialLink}
                  alt="Material pictorial description"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    alignContent: 'center'
                  }}
                />
              </S.ScrollableBlock>

            </>
          ) : (
            <S.ErrorBlock>
              <S.NoDataMessage>No materials required for this Investigation</S.NoDataMessage>
            </S.ErrorBlock>
          )
        ) : (
          <S.ErrorBlock>
            <S.NoDataMessage>No materials required for this Investigation</S.NoDataMessage>
          </S.ErrorBlock>
        )}

        {isOverlayVisible && (
          <S.Overlay
          >
            <S.OverlayContent>
              <S.CloseButton onClick={toggleOverlay}>×</S.CloseButton>
              <div style={{ height: '10px' }} />
              <img
                src={materialData?.qrLink}
                alt="QR pictorial description"
                style={{
                  display: 'block',
                  margin: '0 auto',
                  width: '160px',
                  height: '160px',
                }}
              />
              <a
                href={materialData?.simulationLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'block',
                  textAlign: 'center',
                  marginTop: '15px',
                  color: '#007bff',
                  textDecoration: 'underline',
                }}
              >
                Open QR link in a New Tab
              </a>
            </S.OverlayContent>
          </S.Overlay>
        )}
      </S.TableContainer>

      <S.ActionButtonsWrapper
        style={{
          marginTop: '15px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {shopifyId && <ShopifyWrapper variantId={shopifyId} product={product?.getShopifyProductByHandle} />}
        {(materialData?.simulationLink) && (materialData?.materialLink) && <button
          style={{
            fontSize: '14px',
            borderRadius: '3px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
          }}
          onClick={toggleOverlay}
        >
          View Simulation
        </button>}
      </S.ActionButtonsWrapper>

    </div>



  );


};

export default MaterialTab;